var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy163(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M11.3,21.7h8.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-8.1c-0.6,0-1,0.4-1,1C10.3,21.2,10.7,21.7,11.3,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M79.8,21.7h8.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-8.1c-0.6,0-1,0.4-1,1C78.8,21.2,79.3,21.7,79.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M11.3,24.5h8.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-8.1c-0.6,0-1,0.4-1,1C10.3,24.1,10.7,24.5,11.3,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M87.9,22.5h-8.1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h8.1c0.6,0,1-0.4,1-1C88.9,23,88.5,22.5,87.9,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M87.9,28.5H59.7l-1.9-12.7c0,0,0,0,0-0.1c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1 c0,0,0,0-0.1,0c-0.1-0.1-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0H42.4 c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1 c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0,0,0,0,0.1l-1.9,12.7H11.3c-0.5,0-0.9,0.3-1,0.8c-0.1,0.4,0.1,0.9,0.5,1.1 l26.4,13.4l-5.8,38.4h-4.9c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h46.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-4.9L62,43.7l26.4-13.3 c0.4-0.2,0.6-0.7,0.5-1.1S88.4,28.5,87.9,28.5z M43.1,17.9l4.9,4l-6.3,5.2L43.1,17.9z M57.5,27.1l-6.3-5.2l4.9-4L57.5,27.1z  M55.8,30.5l-6,4.2l-6-4.2H55.8z M43.2,28.5l6.4-5.3l6.4,5.3H43.2z M49.6,20.6L45.2,17H54L49.6,20.6z M48,35.9l-8.4,5.8l1.6-10.6 L48,35.9z M42.2,42.3l7.5-5.2l7.5,5.2L42.2,42.3z M58,44.3l-8.2,5.6l-8.1-5.6H58z M48,51.1L37,58.5l2-13.6L48,51.1z M38.9,59.6 l10.8-7.3l10.6,7.3H38.9z M60.4,61.6l-10.9,7.7l-10.7-7.7H60.4z M36.4,62.4l11.3,8.2l-14,9.9L36.4,62.4z M49.4,71.8l14.4,10.4 H34.7L49.4,71.8z M51.2,70.6l11.6-8.2L65.6,81L51.2,70.6z M51.5,51.1l8.7-5.9l2,13.3L51.5,51.1z M51.5,35.9l6.6-4.6l1.5,10.2 L51.5,35.9z M15.5,30.5h23.8l-1.7,11.2L15.5,30.5z M61.7,41.6L60,30.5h23.7L61.7,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M11.3,27.4h8.1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-8.1c-0.6,0-1,0.4-1,1C10.3,26.9,10.7,27.4,11.3,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M87.9,25.4h-8.1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h8.1c0.6,0,1-0.4,1-1C88.9,25.8,88.5,25.4,87.9,25.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy163);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-163.5f3963d56267346513280014cb9b69a8.svg";
export { ForwardRef as ReactComponent };